/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const accountModule = require('@utils/account/accountModule');
const analyticsModule = require('@utils/analytics/analyticsModule');
const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const getFetchModule = require('@utils/get_fetch/getFetchModule');
const indexModule = require('@utils/index/indexModule');
const templateModule = require('@utils/template/templateModule');
const utilitySelectorModule = require('@utils/utility_selector/utilitySelectorModule');
const RebatesService = require('./rebatesService');
const rebateProviderStatementDirective = require('./rebateProviderStatementDirective');

const rebatesModule = angular
    .module('enervee_utils.rebates', [
        accountModule.name,
        analyticsModule.name,
        cmsModule.name,
        commonModule.name,
        consumersModule.name,
        getFetchModule.name,
        indexModule.name,
        templateModule.name,
        utilitySelectorModule.name,
        'ngFileUpload',
    ])
    .factory('RebatesService', RebatesService)
    .directive('rebateProviderStatement', rebateProviderStatementDirective);

module.exports = rebatesModule;
